module.exports = __webpack_public_path__ + "static/dev_39-f2c948de9773b10b7773e6f7fe5e3981.png";